import handleUntilEventStarts from './ticketOnSaleConditions/handleUntilEventStarts';
import handleDateTimeBased from './ticketOnSaleConditions/handleDateTimeBased';
import handleAfterTicketSalesEnd from './ticketOnSaleConditions/handleAfterTicketSaleEnds';
import handleAfterTicketSellsOut from './ticketOnSaleConditions/handleAfterTicketSellsOut';
import handleAfterTicketSaleEndsOrSellsOut from './ticketOnSaleConditions/handleAfterTicketSaleEndsOrSellsOut';
import checkIsTicketGroupSoldOut from '@repo/checkout/lib/checkIsTicketGroupSoldOut';

export default function checkIsTicketGroupOnSale({ ticketGroup, allTicketGroups = [], page }) {
  if (
    !ticketGroup ||
    ticketGroup.status !== 'enabled' ||
    (ticketGroup.availabilityStatus !== 'available' && ticketGroup.availabilityStatus != null)
  ) {
    return false;
  }

  const now = new Date();
  const availabilityBehavior = ticketGroup.availabilityBehavior || 'always_available';
  const entityKey = 'triggerTicketGroup';

  switch (availabilityBehavior) {
    case 'always_available': {
      return true;
    }
    case 'until_event_starts': {
      return handleUntilEventStarts({ page, now });
    }
    case 'date_time_based': {
      return handleDateTimeBased({ entity: ticketGroup, now });
    }
    case 'after_ticket_sale_ends': {
      return handleAfterTicketSalesEnd({
        entity: ticketGroup,
        allEntities: allTicketGroups,
        entityKey,
        now,
      });
    }
    case 'after_ticket_sold_out': {
      return handleAfterTicketSellsOut({
        entity: ticketGroup,
        allEntities: allTicketGroups,
        now,
        entityKey,
        checkSoldOutFunc: checkIsTicketGroupSoldOut,
      });
    }
    case 'after_ticket_ends_or_sold_out': {
      return handleAfterTicketSaleEndsOrSellsOut({
        entity: ticketGroup,
        allEntities: allTicketGroups,
        now,
        entityKey,
        checkSoldOutFunc: checkIsTicketGroupSoldOut,
      });
    }
    default:
      return true;
  }
}
